import mem from "mem";

import { type Token } from "src/client/models/Token";

import backendClient from "../../../api";
import authService from "../../../services/authService";

const refreshTokenFn = async (): Promise<Token | undefined> => {
  const session = authService.getSession();

  if (!session) return;

  try {
    const result = await backendClient.auth.refreshJwtToken({
      refresh: session?.refreshToken,
    });
    authService.handleAuthentication(result);
    return result;
  } catch (error) {
    authService.logout();
  }
};

const maxAge = 10000;

export const memoizedRefreshToken = mem(refreshTokenFn, {
  maxAge,
});
